export { default as useInputsValidation } from './useInputsValidation';
export {
  type Validations,
  type InputValues,
  type InputValidateFunction
} from './useInputsValidation.types';
